<template>
  <div class="container">
    <loading :active.sync="isLoading" :is-full-page="true" color="#4e97b2"></loading>
    <div class="row">
      <div class="col-lg-6 text-left">
        <h1>Claim Existing Event</h1>
        <div class="mb-3">Your event may already be in our database. Use the search below to claim your event.</div>
        <autocomplete :source="events" :results-display="formattedDisplay" placeholder="Search for an existing event"
          input-class="form-control" @selected="selectedEvent">
        </autocomplete>
      </div>
      <div class="col-lg-6 text-left">
        <h1>Create New Event</h1>
        <span>If you can't find your event, you may also add it. Please don't add duplicate events!</span><br />
        <router-link :to="{ name: 'event create' }" class="event-link-btn">
          <b-button class="mt-3">Create</b-button>
        </router-link>
      </div>
    </div>
    <div>
      <b-card class="mt-5 text-left">
        <h1>Your Events</h1>
        <div v-if="sortingField">
          Sorting By: <b>{{ sortField }}</b>, Sort Direction: <b>{{ sortingOrder === 'asc' ? 'Ascending' : 'Descending'
          }}</b>
        </div>
        <table v-if="userEvents.length > 0" class="table table-sm table-striped">
          <thead>
            <tr>
              <th @click="sort('organizationName')">Organization Name <font-awesome-icon icon="sort" /></th>
              <th @click="sort('name')">Event Name <font-awesome-icon icon="sort" /></th>
              <th>Date Range</th>
              <th>Edit</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="event in userEvents" :key="event._id">
              <td><router-link :to="{ name: 'org detail', params: { orgId: event.organizationId } }">{{
                event.organizationName }}</router-link></td>
              <td><router-link :to="{ name: 'event detail', params: { eventId: event._id } }"
                  class="">{{ event.name }}</router-link></td>
              <td>{{ event.start_on | dateOnly }} - {{ event.end_on | dateOnly }}</td>
              <td><router-link :to="{ name: 'event edit', params: { eventId: event._id } }"
                  class="btn btn-secondary event-link-btn">Edit</router-link></td>
            </tr>
          </tbody>
        </table>
        <span v-else>None of your organizations have events</span>
      </b-card>
    </div>


  </div>
</template>

<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      events: [],
      userEvents: [],
      sortField: '',
      sortingField: '',
      sortingOrder: 'asc',
      displayMap: {
        organizationName: 'Organization Name',
        name: 'Event Name',
      },
    };
  },
  async created() {
    try {
      this.isLoading = true;
      const response = await axios.get(`${process.env.VUE_APP_API_EVENTS_ROOT}/getEventsForUser/${this.$store.state.auth.mUser._id}`);
      this.userEvents = response.data;

      const eventsResponse = await axios.get(`${process.env.VUE_APP_API_EVENTS_ROOT}/events/lean`);
      this.events = eventsResponse.data.events;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  },
  computed: {

  },
  methods: {
    selectedEvent(event) {
      this.$router.push({ name: 'event detail', params: { eventId: event.selectedObject._id } });
    },
    formattedDisplay(result) {
      return `${result.name} -- ${result.city}`;
    },
    compareValues(key, order = 'asc') {
      return function innerSort(a, b) {
        // eslint-disable-next-line
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0;
        const comparison = a[key].localeCompare(b[key]);

        return (
          (order === 'desc') ? (comparison * -1) : comparison
        );
      };
    },
    sort(field) {
      if (this.sortingField === field) {
        this.sortingOrder = this.sortingOrder === 'asc' ? 'desc' : 'asc';
      }
      this.sortingField = field;
      this.userEvents.sort(this.compareValues(this.sortingField, this.sortingOrder));
      this.sortField = this.displayMap[this.sortingField];
    },
  },
};
</script>

<style scoped>
.card {
  border: none;
}

.card-body h1 {
  margin: 0px 0 10px 0;
}

.autocomplete>>>.autocomplete__results {
  color: #2c3e50;
  font-weight: 400;
}

.autocomplete>>>.autocomplete__results__item {
  padding: 7px 15px;
}

.autocomplete>>>.autocomplete__box {
  padding: 0 10px;
}</style>
